(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact_us_app"] && !Shopify.designMode) return;
  try {
    
    (function ([s, ...u]) {
      // Check if the Gorgias contact form already exists
      if (window.gorgiasContactForm) return;
  
      // Set the Gorgias contact form
      window.gorgiasContactForm = s;
  
      // Function to adjust viewport for iPhone
      function E() {
          if (!/iPhone/.test(navigator.userAgent)) return;
          let t = document.querySelector("meta[name=viewport]");
          t || ((t = document.createElement("meta")).setAttribute("name", "viewport"), document.head.appendChild(t));
          t.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no");
      }
  
      // Function to mark performance
      function T(t) {
          let { performance: e } = window;
          if (!e || typeof e.mark != "function") {
              console.error("Performance API is not available");
              return;
          }
          e.mark(t);
      }
  
      // Function to generate iframe URL
      function l(t, e, i, c) {
          let n = `${c}/embed/forms/${t}`;
          return m(t, e, i) && (n += "?new_design=true"), n;
      }
  
      // Function to create iframe
      function d(t, e, i, c) {
          let n = t.getAttribute(e.DATA_ATTRIBUTES.CONTACT_FORM_UID);
          if (!n) return null;
          let A = "gorgias.assigned-number",
              r = localStorage.getItem(A);
          g(n, r, c) && localStorage.setItem(A, Math.floor(100 * Math.random()).toString());
          let a = l(n, r, c, i),
              o = document.createElement("iframe");
          return (
              (o.src = a),
              (o.height = "100%"),
              (o.width = "100%"),
              o.setAttribute("frameborder", "0"),
              o.setAttribute("scrolling", "no"),
              o.setAttribute(e.DATA_ATTRIBUTES.IFRAME, ""),
              t.appendChild(o),
              o
          );
      }
  
      // Function to check if the form should be shown
      function g(t, e, i) {
          return !e && i.includes(t);
      }
  
      // Function to check if the form should use the new design
      function m(t, e, i) {
          return i.includes(t) && e && parseInt(e) % 2 == 1;
      }
  
      // Function to handle iframe messages
      function _(t, e, i, c) {
          T(t.MARKERS.IFRAME_START);
          let n = [];
          e.forEach((r) => {
              let a = d(r, t, i, c);
              a && n.push(a);
          });
          T(t.MARKERS.IFRAME_END);
          let A = {
              [t.MESSAGE_TYPES.CONTACT_FORM_LOADED]: (r) => {
                  var a;
                  (a = r.source) == null || a.postMessage(
                      { type: t.MESSAGE_TYPES.PARENT_URL, parentUrl: window.location.href },
                      { targetOrigin: "*" }
                  );
              },
              [t.MESSAGE_TYPES.ADJUST_IFRAME_HEIGHT]: (r) => {
                  let a = n.find((o) => o.contentWindow === r.source);
                  a && a.setAttribute("height", r.data.height);
              },
          };
          window.addEventListener("message", (r) => {
              let { type: a } = r.data,
                  o = A[a];
              o && o(r);
          });
      }
  
      // Function to render contact form iframe
      function f(t, e, i, c) {
          let { CONTACT_FORM_UID: n } = t.DATA_ATTRIBUTES,
              A = Array.from(document.querySelectorAll(`[${n}]`)).filter((r) => !!r.getAttribute(n)).slice(0, t.CONTACT_FORMS_PER_PAGE_LIMIT);
          e.renderContactFormIframe(t, A, i, c);
      }
  
      // Define an object with render function
      const R = {
          renderContactFormIframe: _,
      };
  
      // Initialize
      E();
      f(s, R, ...u);
  })([
      {
          CONTACT_FORMS_PER_PAGE_LIMIT: 10,
          PARENT_CONTAINER_SELECTOR: '[data-gorgias-contact-form="container"]',
          DATA_ATTRIBUTES: {
              IFRAME: "data-gorgias-iframe-contact-form",
              CONTACT_FORM_UID: "data-gorgias-contact-form-uid",
          },
          MESSAGE_TYPES: {
              CONTACT_FORM_LOADED: "gorgias-contact-form-loaded",
              ADJUST_IFRAME_HEIGHT: "gorgias-adjust-iframe-height",
              PARENT_URL: "gorgias-parent-url",
          },
          MARKERS: {
              IFRAME_START: "gorgias-contact-form-iframe-start",
              IFRAME_END: "gorgias-contact-form-iframe-end",
          },
      },
      "https://contact.gorgias.help",
      ["wvd8enxt", "6kjd4p3y"],
  ]);
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_app"] && !Shopify.designMode) return;
  try {
    
    
    (function ([A, ...u]) {
      // Check if the gorgiasHelpCenter object already exists
      if (window.gorgiasHelpCenter) return;
      
      // Set the gorgiasHelpCenter object
      window.gorgiasHelpCenter = A;
  
      // Function to adjust viewport for iPhone
      function _() {
          if (!/iPhone/.test(navigator.userAgent)) return;
          let e = document.querySelector("meta[name=viewport]");
          e || ((e = document.createElement("meta")).setAttribute("name", "viewport"), document.head.appendChild(e));
          e.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no");
      }
  
      // Function to mark performance
      function T(e) {
          let { performance: o } = window;
          if (!o || typeof o.mark != "function") {
              console.error("Performance API is not available");
              return;
          }
          o.mark(e);
      }
  
      // Function to create iframe
      function d(e, o, E, l) {
          T(e.MARKERS.IFRAME_START);
          let n = [];
          E.forEach((t) => {
              let r = t.hasAttribute(e.DATA_ATTRIBUTES.FULL_WIDTH_EMBEDMENT),
                  i = t;
              for (; r && i && i.tagName !== "BODY"; ) {
                  i.style.maxWidth = "100vw";
                  i = i.parentElement;
              }
              let a = document.createElement("iframe"),
                  c = t.getAttribute(e.DATA_ATTRIBUTES.HELP_CENTER_UID),
                  S = o.searchParams.get("hcUrl") || "";
              a.src = `${l}/embed/help-centers/${c}?path=${S}`;
              a.height = "100%";
              a.width = "100%";
              a.setAttribute("frameborder", "0");
              a.setAttribute("scrolling", "no");
              a.id = c || "";
              t.appendChild(a);
              n.push(a);
          });
          T(e.MARKERS.IFRAME_END);
          let s = {
              [e.MESSAGE_TYPES.CONTACT_FORM_LOADED]: (t) => {
                  var r;
                  (r = t.source) == null || r.postMessage(
                      { type: e.MESSAGE_TYPES.PARENT_URL, parentUrl: window.location.href },
                      { targetOrigin: "*" }
                  );
              },
              [e.MESSAGE_TYPES.ADJUST_IFRAME_HEIGHT]: (t) => {
                  let r = n.find((a) => a.contentWindow === t.source);
                  if (!r) return;
                  let i = t.data.height;
                  r.setAttribute("height", i);
                  r.setAttribute("style", `height: ${i}px;`);
              },
              [e.MESSAGE_TYPES.ROUTE_CHANGE]: (t) => {
                  o.searchParams.set("hcUrl", t.data.url);
                  window.history.replaceState(null, "", o.href);
              },
              [e.MESSAGE_TYPES.SCROLL_TO_TOP]: () => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
              },
          };
          window.addEventListener("message", (t) => {
              let { type: r } = t.data,
                  i = s[r];
              i && i(t);
          });
      }
  
      // Function to render help center iframe
      function h(e, o, E, l) {
          let { DATA_ATTRIBUTES: { HELP_CENTER_UID: n }, HELP_CENTERS_PER_PAGE_LIMIT: s } = e,
              t = Array.from(document.querySelectorAll(`[${n}]`)).filter((r) => !!r.getAttribute(n)).slice(0, s);
          E.buildHelpCenterIframe(e, o, t, l);
      }
  
      // Function to enable smooth scrolling
      function m() {
          document.documentElement.style.scrollBehavior = "smooth";
      }
  
      // Define an object with build function
      const g = {
          buildHelpCenterIframe: d,
      };
  
      // Get current URL
      const R = new URL(window.location.href);
  
      // Initialize
      m();
      _();
      h(A, R, g, ...u);
  })([
      {
          HELP_CENTERS_PER_PAGE_LIMIT: 2,
          DATA_ATTRIBUTES: {
              HELP_CENTER_UID: "data-gorgias-help-center-uid",
              FULL_WIDTH_EMBEDMENT: "data-gorgias-embedment-full-width",
          },
          MESSAGE_TYPES: {
              CONTACT_FORM_LOADED: "gorgias-contact-form-loaded",
              ADJUST_IFRAME_HEIGHT: "gorgias-adjust-iframe-height",
              ROUTE_CHANGE: "gorgias-adjust-parent-url",
              SCROLL_TO_TOP: "gorgias-scroll-to-top",
              PARENT_URL: "gorgias-parent-url",
          },
          MARKERS: {
              IFRAME_START: "gorgias-help-center-iframe-start",
              IFRAME_END: "gorgias-help-center-iframe-end",
          },
      },
      "https://help-center.gorgias.help"
  ]);
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube_video"] && !Shopify.designMode) return;
  try {
    

$(".video_tab_btn").on('click',function(ev){
  $(".iframe-pop-up").show();
 $(".iframe-pop-up .main-video-if").html($(this).parent().find("iframe").clone()); 
 ev.preventDefault();
  $("body").addClass("pop-up-overflow-hide");
});

  $("#close-if").on('click',function(){
     $(".iframe-pop-up .main-video-if").html("");    
     $(".iframe-pop-up").hide();
     $("body").removeClass("pop-up-overflow-hide");
  });

  } catch(e) { console.error(e); }
})();
})();
